// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NavPanelContentTitle_wrapper__1TO6l","title":"NavPanelContentTitle_title__1OK1F"};